import $ from 'jquery';

export default function inputNumberDirective(context=document.body) {
	const disabledClass = 'is-disabled';

	function validValue(value) {
		const intValue = parseInt(value);
		return !isNaN(intValue) && intValue > 0;
	}

	function getNewValue(inputVal, addedVal) {
		let newValue = 1;

		if (validValue(inputVal)) {
			newValue = parseInt(inputVal) + addedVal;

			if (newValue < 1) {
				newValue = 1;
			}
		}

		return newValue;
	}

	$(context).find('[sw-input-number]').each(function() {
		const $this = $(this);
		const $input = $this.children('input').first();
		const $upArrow = $this.children('[sw-input-number-up]').first();
		const $downArrow = $this.children('[sw-input-number-down]').first();
		let arrowTimeout;

		function applyDownArrowState(value) {
			if (value > 1 && $downArrow.hasClass(disabledClass)) {
				$downArrow.removeClass(disabledClass);
			} else if (value === 1 && !$downArrow.hasClass(disabledClass)) {
				$downArrow.addClass(disabledClass);
			}
		}

		function applyNewValue(addedVal) {
			const newValue = getNewValue($input.val(), addedVal);
			$input.val(newValue);
			applyDownArrowState(newValue);
		}

		function setArrowTimeout(firstTimeout, nextTimeout, value) {
			return setTimeout(() => {
				applyNewValue(value);
				if ($input.val() > 1) {
					arrowTimeout = setArrowTimeout(nextTimeout, nextTimeout, value)
				} else {
					arrowTimeout = false;
				}
			}, firstTimeout);
		}

		$input.on('change keyup', () => {
			let value = $input.val();

			if (validValue(value)) {
				const wasInt = /^(\d+)$/.test(value);
				value = parseInt(value);

				if (!wasInt) {
					$input.val(value);
				}

				applyDownArrowState(value);
			} else {
				const containedNumber = value.match(/(\d+)/);

				if (containedNumber !== null) {
					value = parseInt(containedNumber[0]);
				} else {
					value = 1;
				}

				$input.val(value);
			}
	
			applyDownArrowState(value);
		});

		$upArrow.on('mousedown', () => {
			applyNewValue(1);
			arrowTimeout = setArrowTimeout(500, 100, 1);
		});
		$downArrow.on('mousedown', () => {
			applyNewValue(-1);
			arrowTimeout = setArrowTimeout(500, 100, -1);
		});

		$upArrow.on('mouseup mouseout', () => {
			clearTimeout(arrowTimeout);
			arrowTimeout = false;
			$input.trigger('change');
		});
		$downArrow.on('mouseup mouseout', () => {
			clearTimeout(arrowTimeout);
			arrowTimeout = false;
			$input.trigger('change');
		});
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/input-number.js